export interface ConfirmRejectionReason {
    value: number;
    text: string;
}

export const REJECTION_REASONS: ConfirmRejectionReason[] = [
    {
        text: 'Incorrect account holder',
        value: 1
    },
    {
        text: 'Incorrect account number',
        value: 2
    },
    {
        text: 'Incorrect routing (ABA) number',
        value: 3
    },
    {
        text: 'I decided to get a check',
        value: 4
    },
    {
        text: 'Other',
        value: 0
    }
];